import React, {useEffect} from 'react'
import AppContainer from "../../components/container/AppContainer";
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import Section from "../../components/container/Section";
import styled from "@emotion/styled";
import ThirtyThreePercentCard from "../../components/card/ThirtyThreePercentCard";
import {GAPageView} from "../../services/AnalyticsService";

const Contact = () => {
    useEffect(() => {
        GAPageView("Contact")
    }, []);

    return (
        <AppContainer>
            <Section
                marginVertical={50}
                paddingHorizontal={20}
            >
                <MainTitleContainer>
                    <Text
                        type={"h4"}
                        color={Colors.green}
                    >
                        Contact
                    </Text>
                </MainTitleContainer>

                <Text>
                    Pour toutes questions supplémentaires et relatives à notre activité ou pour l’élaboration gratuite
                    d’un devis, vous pouvez nous contacter, nous serions ravis de vous compter parmi nos clients.
                </Text>
            </Section>

            <Section
                flexDirection={"row"}
                marginVertical={70}
            >
                <ThirtyThreePercentCard>
                    <ImageIcon className="fas fa-phone" />

                    <TitleContainer>
                        <Text type={"h5"}>Téléphone</Text>
                    </TitleContainer>

                    <Text>06.14.90.64.43</Text>
                </ThirtyThreePercentCard>

                <ThirtyThreePercentCard>
                    <ImageIcon className="fas fa-at" />

                    <TitleContainer>
                        <Text type={"h5"}>Email</Text>
                    </TitleContainer>

                    <Text>ecopaturhin@gmail.com</Text>
                </ThirtyThreePercentCard>

                <ThirtyThreePercentCard>
                    <ImageIcon className="fas fa-envelope" />

                    <TitleContainer>
                        <Text type={"h5"}>Siege Social</Text>
                    </TitleContainer>

                    <Text>SAS Ecopatu’Rhin, 55 route de Bâle, 68740 Balgau</Text>
                </ThirtyThreePercentCard>
            </Section>
        </AppContainer>
    )
}

export default Contact

const MainTitleContainer = styled.div`
  margin-bottom: 25px;
`

const TitleContainer = styled.div`
  margin-bottom: 10px;
`

const ImageIcon = styled.i`
  font-size: 3em;
  margin-bottom: 30px;
  color: ${Colors.green};
`
